import React, { Component } from 'react'


export default class EVSTriggerRandom extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div className="text-center">
           
          <h2>The most likely cause for this type of dizziness is a type of Episodic Vestibular Syndrome (EVS).</h2>
          <p>Often, these conditions are either triggered by a specific type of movement, or they begin randomly.</p>
          <h4 > When do you notice dizziness occurring?</h4>
         
          <div className="row mt-5">
              
         
              <button className="btn btn btn-outline-dark offset-lg-1 col-lg-4"  onClick={onClick.bind(this,7,false)}>It seems to be triggered by certain things</button>
              <button className="btn btn btn-outline-dark  offset-lg-1 col-lg-4"  onClick={onClick.bind(this,12,false)}>It seems to start randomly with no specific cause</button>
             
          </div>
         
        </div>

    )
  }
}
